<section id="nav-bar">
  <nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" href="#"
      ><img alt="logo" src="../assets/images/logo.png"
    /></a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="homepageLink">HOME</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="residential">RESIDENTIAL</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="commercial">COMMERCIAL</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="ourteamLink">OUR TEAM</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="companyPage">COMPANY</a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" [routerLink]="listings_page">LISTINGS</a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" [routerLink]="blogPage">BLOGS</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="contactPage">CONTACT</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://stridecareer.com/">JOIN</a>
        </li>
        <li class="nav-item">
          <a class="nav-link login-option" href="https://strideusers.com/"
            >LOGIN</a
          >
        </li>
      </ul>
    </div>
  </nav>
</section>
